/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_EmptyInputs */

const en_tasks_panel_empty = /** @type {(inputs: Tasks_Panel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active task`)
};

const fr_tasks_panel_empty = /** @type {(inputs: Tasks_Panel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune tâche en cours`)
};

const ms_sg2_tasks_panel_empty = /** @type {(inputs: Tasks_Panel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada tugasan aktif`)
};

/**
* | output |
* | --- |
* | "No active task" |
*
* @param {Tasks_Panel_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_empty = /** @type {((inputs?: Tasks_Panel_EmptyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_EmptyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_empty(inputs)
	if (locale === "fr") return fr_tasks_panel_empty(inputs)
	return ms_sg2_tasks_panel_empty(inputs)
});